export const SAILINGLIVE_SEARCH_RESULTS = "SAILINGLIVE_LAST_SEARCH";
export const SAILINGLIVE_REGIONS = "SAILINGLIVE_REGIONS";
export const SAILINGLIVE_EVENTS_DATES = "SAILINGLIVE_EVENTS_DATES";
export const SAILINGLIVE_YEARS = "SAILINGLIVE_YEARS";
export const SAILINGLIVE_YEAR_MONTHS = "SAILINGLIVE_YEAR_MONTHS";
